/**
 * Declare all the Admin API's
 */
export class AdminApis {
    static getPermissionsUri = '/InContactAPI/services/v23.0/permissions?agentId={agentId}';
    static getAgentSettingsUri = '/InContactAPI/services/v23.0/agents/{agentId}/agent-settings';
    static getBusinessUnitUri = '/InContactAPI/services/v23.0/business-unit';
    static getClientDataUri = '/InContactAPI/services/v23.0/agents/client-data?agentId={agentId}';
    static getCentralBrandingProfileUri = '/InContactAPI/services/v23.0/branding-profiles?businessUnitId={businessUnitId}';
    static getUHBrandingProfileUri = '/branding-profiles/current';
    static getScriptData='/InContactAPI/services/v23.0/scripts/';
    static spawnScriptUri='/InContactAPI/services/v23.0/scripts/{scriptId}/start';
    static signalScriptUri = '/InContactAPI/services/v23.0/interactions/{contactId}/signal';
    static getAllIndicatorsUri = '/InContactAPI/services/v23.0/agents/{agentId}/indicators';
}
